var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24904 20.2461C2.02195 20.2461 1.02716 19.2253 1.02716 17.9649V8.79614C1.02716 8.10343 1.33445 7.44718 1.86049 7.01489L7.97195 1.99614C8.36243 1.67279 8.85351 1.49585 9.36049 1.49585C9.86747 1.49585 10.3586 1.67279 10.749 1.99614L16.8595 7.01489C17.3865 7.44718 17.6938 8.10343 17.6938 8.79614V17.9649C17.6938 19.2253 16.699 20.2461 15.472 20.2461H3.24904Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75635 20.2461V14.5169C6.75635 13.9644 6.97584 13.4345 7.36654 13.0438C7.75724 12.6531 8.28715 12.4336 8.83968 12.4336H9.88135C10.4339 12.4336 10.9638 12.6531 11.3545 13.0438C11.7452 13.4345 11.9647 13.9644 11.9647 14.5169V20.2461",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.2002f36ace4c4766871a62bf9cd85d42.svg";
export { ForwardRef as ReactComponent };